module.exports = __webpack_public_path__ + "img/main_8.4669b5e5.jpg";